import { sql } from "drizzle-orm";
import { foreignKey, jsonb, pgTable, text, uuid } from "drizzle-orm/pg-core";
import { entityTable } from "./entity";
import { roomTable } from "./room";
import { numberTimestamp } from "./types";

/**
 * Represents a PostgreSQL table for storing logs.
 *
 * @type {Table}
 */

export const logTable = pgTable(
	"logs",
	{
		id: uuid("id").defaultRandom().notNull(),
		createdAt: numberTimestamp("createdAt").default(sql`now()`).notNull(),
		entityId: uuid("entityId")
			.notNull()
			.references(() => entityTable.id),
		body: jsonb("body").notNull(),
		type: text("type").notNull(),
		roomId: uuid("roomId")
			.notNull()
			.references(() => roomTable.id),
	},
	(table) => [
		foreignKey({
			name: "fk_room",
			columns: [table.roomId],
			foreignColumns: [roomTable.id],
		}).onDelete("cascade"),
		foreignKey({
			name: "fk_user",
			columns: [table.entityId],
			foreignColumns: [entityTable.id],
		}).onDelete("cascade"),
	],
);
